import { render, staticRenderFns } from "./skillRating.vue?vue&type=template&id=4f60fd81&scoped=true&"
import script from "./skillRating.vue?vue&type=script&lang=js&"
export * from "./skillRating.vue?vue&type=script&lang=js&"
import style0 from "./skillRating.vue?vue&type=style&index=0&id=4f60fd81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60fd81",
  null
  
)

export default component.exports